import { Grid } from '@mui/material';

import { Card, InfoField, CardContent, Typography } from '@occc/ui-design-system';

export type MemberProfileAttributesCardProps = {
  username: string;
  password: string;
  portNumber: string;
  submissionUrl: string;
  submissionStatus: string;
  submitterId: string;
};

export const SFTPAttributesCard = ({
  username,
  password,
  portNumber,
  submissionUrl,
  submissionStatus,
  submitterId,
}: MemberProfileAttributesCardProps) => {
  const maskedPassword = password ? '••••••••' : '';

  return (
    <Card sx={{ mb: 1 }}>
      <CardContent>
        <Typography variant='h6' mb={2}>
          Group Details
        </Typography>
        <Grid container spacing={3}>
          <Grid item sm={6} md={4}>
            <InfoField label='Username' value={username} truncate />
          </Grid>
          <Grid item sm={6} md={4}>
            <InfoField label='Password' value={maskedPassword} />
          </Grid>
          <Grid item sm={6} md={4}>
            <InfoField label='Port Number' value={portNumber} />
          </Grid>
          <Grid item sm={6} md={4}>
            <InfoField label='Submission URL' value={submissionUrl} truncate />
          </Grid>
          <Grid item sm={6} md={4}>
            <InfoField label='Submission Status' value={submissionStatus} />
          </Grid>
          <Grid item sm={6} md={4}>
            <InfoField label='Submitter ID' value={submitterId} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
